import { isChromeBasedBrowser } from '../utils'

export const SYNC_CONTACTS_EXTENSION_REQUIRED_TOOLTIP =
    'Download LeadDelta Chrome app first and then sync your contacts.'

export const SYNC_CONTACTS_CHROMIUM_BROWSER_REQUIRED_TOOLTIP =
    'Use a Chromium-based browser such as Chrome to sync your LinkedIn contacts.'

export const getSyncContactsTooltip = (extensionInstalled = false): string => {
    if (!isChromeBasedBrowser()) return SYNC_CONTACTS_CHROMIUM_BROWSER_REQUIRED_TOOLTIP
    return extensionInstalled ? '' : SYNC_CONTACTS_EXTENSION_REQUIRED_TOOLTIP
}

export const getInboxAccessBlockedTooltip = ({
    isStarterLocked,
    extensionInstalled,
    extensionVersion,
    isLoggedToLinkedin,
    isSynced,
    appVersion = process.env.REACT_APP_VERSION,
}: {
    isStarterLocked?: boolean
    extensionInstalled: boolean
    extensionVersion?: string
    isLoggedToLinkedin: boolean
    isSynced?: boolean
    appVersion?: string
}): string => {
    if (isStarterLocked) return 'Upgrade to Pro to unlock this feature'
    if (!isChromeBasedBrowser()) return SYNC_CONTACTS_CHROMIUM_BROWSER_REQUIRED_TOOLTIP
    if (!extensionInstalled) return 'Please install the extension and sync your contacts'
    if (extensionVersion !== appVersion) return 'Update the LeadDelta extension'
    if (!isLoggedToLinkedin) return 'Please log in to LinkedIn to continue use inbox'
    if (!isSynced) return 'Please sync your contacts'
    return ''
}
